// Helper: Resize Shopify image
const getResizedImageUrl = (url) => {
  const regex = /(\.[a-zA-Z0-9]+)(\?v=\d+)?$/;
  return url.replace(regex, (match, ext, version) => {
    return `_400x${ext}${version || ''}`;
  });
};
const pageSize = 24;
const urlParams = new URLSearchParams(window.location.search);
const page = parseInt(urlParams.get("page") || "1", 10); // Default to 1 if no page param
const start = (page - 1) * pageSize;

// Main handler
const handleNostoApiCall = async (start, append = false, url, callback = null) => {
  const startTime = performance.now();

  const params = new URLSearchParams(url);
  let searchParams = url.slice(1);
  let sortByValue = null;
  let sortField = "";
  let sortOrder = "";
  let minPrice = "5";
  let maxPrice = "100";
  let customCollection = [];
  let sizes = [];
  let colors = [];
  let bassoms = [];

  // sort by logic
  if (searchParams.trim() != '' && searchParams.includes('&')) {
    let searchItems = searchParams.split('&');
    searchItems.forEach(param => {
      if (param.startsWith("sort_by=")) {
        sortByValue = param.split('=')[1];
      }
      if (param.includes("gte=")) {
        minPrice = param.split('=')[1];
      }
      if (param.includes("lte=")) {
        maxPrice = param.split('=')[1];
      }
      if (param.includes("custom.collection=")) {
        const value = param.split('=')[1].replace(/\+/g, ' ');
        customCollection.push(`["${value}"]`);
      }
      // if (param.includes("custom.color_hex=")) {
      //   // colors.push(`${param.split('=')[1].split('%')[0]}`);
      //   const rawValue = decodeURIComponent(param.split('=')[1]); // e.g., "Weiß|#FFFFFF"
      //   const colorName = rawValue.split('|')[0]; // e.g., "Weiß"
      //   colors.push(colorName);
      // }

      if (param.includes("custom.color_hex=")) {
        const colorMap = JSON.parse(
          document.getElementById('color-hex-map').textContent
        );
        document.querySelectorAll('input.color-facet-r').forEach(input => {
          const label = input.getAttribute('value'); // e.g. "Blanc|#FFFFFF" (translated)
          const hex = label.split('|')[1]?.toUpperCase();

          if (hex && colorMap[hex]) {
            input.setAttribute('data-raw', colorMap[hex]); // e.g. "Weiß|#FFFFFF"
          } else {
            input.setAttribute('data-raw', hex); // fallback to just hex
          }
        });
        let rawVal = param.split('=')[1]; // Still URL-encoded
        rawVal = rawVal.replace(/\+/g, ' '); // Replace + with space
        const paramVal = decodeURIComponent(rawVal); // e.g. "Blanc|#FFFFFF"
        const matchingInput = document.querySelector(`input.color-facet-r[value="${paramVal}"]`);

        if (matchingInput) {
          const raw = matchingInput.getAttribute('data-raw'); // "Weiß|#FFFFFF"
          const colorName = raw?.split('|')[0]; // "Weiß"
          console.log(colorName, 'colorName')
          if (colorName) colors.push(colorName);
        } else {
          // fallback if data-raw not found
          const fallbackColor = paramVal.split('|')[0];
          colors.push(fallbackColor);
        }
      }

      if (param.includes("option.size=")) {
        sizes.push(param.split('=')[1]);
      }
      if (param.includes("custom.booty_passform=")) {
        bassoms.push(`[\"${param.split('=')[1].replace(/\+/g, " ")}\"]`);
      }
    });
  } else if (searchParams.trim() != '') {
    if (searchParams.includes("sort_by=")) {
      sortByValue = searchParams.split("=")[1];
    }
    if (searchParams.includes("custom.collection=")) {
      const value = searchParams.split('=')[1].replace(/\+/g, ' ');
      customCollection.push(`["${value}"]`);
    }
    if (searchParams.includes("custom.color_hex=")) {
      colors.push(`${searchParams.split('=')[1].split('%')[0]}`);
    }
    if (searchParams.includes("option.size=")) {
      sizes.push(searchParams.split('=')[1]);
    }
    if (searchParams.includes("custom.booty_passform=")) {
      bassoms.push(`[\"${searchParams.split('=')[1].replace(/\+/g, " ")}\"]`);
    }
  }

  if (sortByValue === "price-ascending") {
    sortField = "price";
    sortOrder = "asc";
  } else if (sortByValue === "price-descending") {
    sortField = "price";
    sortOrder = "desc";
  }

  let filters = [];

  if (customCollection.length > 0) {
    filters.push({
      "field": "customFields.custom-collection",
      "value": customCollection
    });
  }

  if (colors.length > 0) {
    filters.push({
      "field": "extra.color",
      "value": colors
    });
  }

  if (sizes.length > 0) {
    filters.push({
      "field": "skus.customFields.size",
      "value": sizes
    });

    filters.push({
      "field": "skus.availability",
      "value": "InStock"
    });
  }

  if (bassoms.length > 0) {
    filters.push({
      "field": "customFields.custom-booty_passform",
      "value": bassoms
    });
  }

  if (minPrice && maxPrice) {
    filters.push({
      "field": "price",
      "range": [
        {
          "gte": minPrice,
          "lte": maxPrice
        }
      ]
    });
  }

  // Optional: Push search query to GA4
  if (params.has('q')) {
    const searchTerm = params.get('q');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'search', search_term: searchTerm });
  }
  const XsearchParams = new URLSearchParams(window.location.search);

  const searchTerm = XsearchParams.get('q');


  try {
    const response = await new Promise((resolve, reject) => {
      nostojs(api => {
        api.search({
          query: searchTerm,
          products: {
            facets: ['*'],
            fields: ['productId', 'name', 'url', 'imageUrl', 'price', 'alternateImageUrls'],
            sort: sortField ? [{ field: sortField, order: sortOrder }] : [],
            filter: [{ all: filters }],
            size: pageSize,
            from: start
          }
        }, { track: 'serp', redirect: true, isKeyword: true }).then(resolve).catch(reject);
      });
    });

    const productsWrapper = document.querySelector('#product-grid');
    const productLoader = document.querySelector('.loader_element');
    const emptyText = document.querySelector('.title-wrapper__empty');
    const productCountWrapper = document.querySelector('[data-products-count-text]');
    const loadingBtn = document.querySelector('#loading_next .button');


    if (productsWrapper && productLoader && emptyText) {
      const products = response.products?.hits || [];
      const resultId = response.result_id;
      const totalResults = response.products?.total || 0;
      if (products.length > 0) {
        const firstVariantIds = products.map(p => p.skus?.[0]?.id).filter(Boolean);
        const productHandles = products.map(p => p.url).filter(Boolean);
        const useHandles = productHandles[0]?.startsWith("https://teveo.com/products");

        const requests = useHandles
          ? productHandles.map(url => {
            const path = new URL(url).pathname;
            const marketUrl = window.routes.root_url.replace(/\/$/, '');
            return fetchProductCardHTML(`${marketUrl}${path}`, 'recommended-products__item', true);
          })
          : firstVariantIds.map(id => fetchProductCardHTMLByFirstVariant(id, 'recommended-products__item'));

        const responses = await Promise.all(requests);
        const cardsHtml = responses.join('');

        const tempWrapper = document.createElement('div');
        tempWrapper.innerHTML = cardsHtml;

        tempWrapper.querySelectorAll('.product-details__wrapper a').forEach(a => {
          try {
            const url = new URL(a.href);
            url.searchParams.set('nosto', resultId);
            a.href = url.toString();
          } catch (e) {
            console.warn('Invalid product link', a.href);
          }
        });

        tempWrapper.querySelectorAll('.recommended-products__item').forEach(el => {
          el.classList.remove('recommended-products__item');
          el.classList.add('grid__item');
        });

        const newItems = tempWrapper.querySelectorAll('.grid__item');

        if (!append) productsWrapper.innerHTML = '';
        newItems.forEach(item => productsWrapper.appendChild(item));

        // newItems.forEach((item, index) => {
        //   const product = products[index];
        //   if (!product) return;

        //   const productId = product.productId;
        //   const productUrl = product.url;

        //   const link = item.querySelector('a[href*="/products/"]');
        //   if (link && window.nostojs) {
        //     link.addEventListener('click', () => {
        //       nostojs(api => {
        //         api.recordSearchClick('serp', { productId, url: productUrl });
        //       });
        //     });
        //   }

        //   const buttons = item.querySelectorAll('.sizes__wrapper--item:not([disabled]), .size-button:not([disabled])');
        //   buttons.forEach(button => {
        //     button.addEventListener('click', () => {
        //       const variantId = button.dataset.variant || button.dataset.variantId;
        //       const productHandle = button.dataset.productHandle || button.closest('[data-product-handle]')?.dataset.productHandle;
        //       const productId = button.dataset.productId || button.closest('[data-product-id]')?.dataset.productId;
        //       const productUrl = `https://teveo.com/products/${productHandle}`;

        //       if (productId && productUrl && window.nostojs) {
        //         nostojs(api => {
        //           api.recordSearchAddToCart('serp', { productId, url: productUrl });
        //         });
        //       }
        //     });
        //   });
        // });

        // ✅ Nosto Tracking: Clicks + Add-to-Cart
        newItems.forEach((item, index) => {
          const product = products[index];
          if (!product) return;

          const productId = product.productId;
          const productUrl = product.url;

          // ✅ Track search click on product link
          const link = item.querySelector('a[href*="/products/"]');
          if (link) {
            link.addEventListener('click', () => {
              nostojs(api => {
                api.recordSearchClick('serp', {
                  productId,
                  url: productUrl
                });
              });
            });
          }

          // ✅ Track add-to-cart clicks only for buttons inside *this* item
          const buttons = item.querySelectorAll('.sizes__wrapper--item:not([disabled]), .size-button:not([disabled])');
          buttons.forEach(button => {
            button.addEventListener('click', () => {
              const variantId = button.dataset.variant || button.dataset.variantId;
              const productHandle = button.dataset.productHandle || button.closest('[data-product-handle]')?.dataset.productHandle;
              const productId = button.dataset.productId || button.closest('[data-product-id]')?.dataset.productId;

              // Fallback to build product URL
              const productUrl = `https://teveo.com/products/${productHandle}`;
              if (productId && productUrl) {
                nostojs(api => {
                  api.recordSearchAddToCart('serp', {
                    productId,
                    url: productUrl
                  });
                });
              } else {
                console.warn('Missing productId or productHandle for Nosto AddToCart tracking');
              }
            });
          });

        });

        productLoader.classList.add('hidden');
        productsWrapper.classList.remove('hidden');
        emptyText.classList.add('hidden');
        const facetRemoves = document.querySelectorAll('facet-remove');
        facetRemoves.forEach(facetRemove => {
          const link = facetRemove.querySelector('a');
          if (!link) return;

          link.addEventListener('click', (event) => {
            event.preventDefault();
            let containerSelector;

            if (facetRemove.classList.contains('mobile-facets__clear-wrapper')) {
              containerSelector = '#facets__container_mobile'; // mobile

            } else if (facetRemove.closest('.active-facets')) {
              containerSelector = '#FacetFiltersForm'; // desktop

            } else {
              console.log('Unknown facet-remove type:', facetRemove);
              return; // unknown type, skip
            }

            // Build search URL from link's query params
            const url = `/search?${link.href.split('?')[1] || ''}`;

            fetch(url)
              .then(response => response.text())
              .then(htmlText => {
                const parser = new DOMParser();
                const htmlDoc = parser.parseFromString(htmlText, 'text/html');

                const newFacets = htmlDoc.querySelector(containerSelector);
                const currentFacets = document.querySelector(containerSelector);

                if (newFacets && currentFacets) {
                  currentFacets.innerHTML = newFacets.innerHTML;
                  console.log('Facets updated for', containerSelector);

                  // Optional: re-bind click listeners for new filters
                  currentFacets.querySelectorAll('a').forEach(a => {
                    a.addEventListener('click', (e) => {
                      e.preventDefault();
                      // handle individual filter clicks here
                    });
                  });

                  // ✅ Update mobile filter button label
                  const newMobileFilterButton = htmlDoc.querySelector('.mobile-facets__open');
                  const currentMobileFilterButton = document.querySelector('.mobile-facets__open');
                  if (newMobileFilterButton && currentMobileFilterButton) {
                    currentMobileFilterButton.innerHTML = newMobileFilterButton.innerHTML;

                    // Remove "(X)" from label
                    const labelEl = currentMobileFilterButton.querySelector('.mobile-facets__open-label');
                    if (labelEl) {
                      labelEl.textContent = labelEl.textContent.replace(/\(\d+\)/, '').trim();
                    }
                  }
                }
              })
              .catch(err => console.error('Error fetching facets:', err));
          });
        });
        // Select the label span
        const filterLabel = document.querySelector('.mobile-facets__open-label.button-label');

        if (!filterLabel) return;

        // Get the current URL including query params
        const currentURL = new URL(window.location.href);

        // Count the number of filter parameters in the URL
        // Adjust this if your filter params have specific prefixes
        // Example: all query params except 'page' and 'sort_by'
        const ignoredParams = ['page', 'sort_by', 'q', 'options[prefix]']; // ignore pagination, sorting, search query
        let filterCount = 0;

        currentURL.searchParams.forEach((value, key) => {
          if (!ignoredParams.includes(key)) filterCount++;
        });

        // Update the span text
        if (filterCount > 0){
          filterLabel.textContent = `Filter (${filterCount})`;
        }
        else{
          filterLabel.textContent = `Filter`;
        }
        if (productCountWrapper && loadingBtn) {
          let currentProducts = products.length;
          if (append) {
            currentProducts = parseInt(loadingBtn.getAttribute('data-hits') || '0') + products.length;
            loadingBtn.classList.remove('loading-products');
            loadingBtn.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
          }

          loadingBtn.setAttribute('data-hits', currentProducts);
          loadingBtn.setAttribute('data-total', totalResults);

          const productCountsText = {
            '{{total_products}}': totalResults,
            '{{current_products}}': currentProducts
          };

          if (currentProducts === totalResults) loadingBtn.classList.add('hidden');

          productCountWrapper.querySelector('span').innerHTML =
            productCountWrapper.dataset.productsCountText.replace(/{{total_products}}|{{current_products}}/gi, matched => productCountsText[matched]);

          loadingBtn.classList.remove('hidden');
          productCountWrapper.classList.remove('hidden');

          initButtons();
        }
      } else {
        productLoader.classList.add('hidden');
        emptyText.classList.remove('hidden');
        if (loadingBtn) loadingBtn.classList.add('hidden');
        if (productCountWrapper) productCountWrapper.classList.add('hidden');
      }
    }
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

    const endTime = performance.now();
    console.log(`handleNostoApiCall (Search) took ${endTime - startTime} ms`);

    if (typeof callback === 'function') {
      callback();
    }
  } catch (error) {
    console.log("Nosto Logs: ", error);
  }
};

handleNostoApiCall(start, false, window.location.search);